import { REMOVE_USER_ADDRESS_REQUEST, REMOVE_USER_ADDRESS_SUCCESS, REMOVE_USER_ADDRESS_FAILURE } from '../../constants/user_address.constants';

export const removeUserAddressRequest = (address_id, user_id) => ({ type: REMOVE_USER_ADDRESS_REQUEST, address_id, user_id });
export const removeUserAddressRequestSuccess = payload => ({ type: REMOVE_USER_ADDRESS_SUCCESS, payload });
export const removeUserAddressRequestFailure = error => ({ type: REMOVE_USER_ADDRESS_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_addresses_actions/remove_user_address.action.js